angular.module('cvsApp').service('decryptUtilityService', ['networkService', 'xdrService', 'configManager',
    'decryptUtilityModel', 'cvsAppData', '$base64', function (NS, XS, CM, DM, CAD, $base64) {

        function decryptUtility() {
            this.decrypt = function (callBackSuccess, encryptObj) {
         
                var apikey = CAD.getApiKey();
                var url = CM.getAGPAPIUrl('UTILITY_DECRYPT');
                
                if (url === "URL_ERROR") {

                } else {

                    //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                    var request = {
                        url: url,
                        header: {
                            'Content-Type': 'application/json',
                            'accept': 'application/json',
                            'type':'rememberMe'
                        },
                        data: requestBody(encryptObj),
                        onSuccess: callBackSuccess
                    }
                    cvsUtility.commonServiceCode(url, "decryptUtility", DM, request, callBackSuccess, NS);
                }

            }

            var requestBody = function (encryptObj) {
                var apikey = CAD.getApiKey();
                var reqObj = {};

                reqObj = {
                    "decryptRequest":{
                       "header": {
                          "serviceContext": {
                             "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                             "lineOfBusiness": "Specialty",
                             "channelName": cvsUtility.queryMap.channel,
                             "responseFormat": "JSON"
                          },
                          "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                       },
                       "details": encryptObj
                    }
                    }
                
                return reqObj;
            }

        }

       return new decryptUtility();
    }]);